import { render, staticRenderFns } from "./ElementsQuestionSingleMultiple.vue?vue&type=template&id=70a44aa4"
import script from "./ElementsQuestionSingleMultiple.vue?vue&type=script&lang=js"
export * from "./ElementsQuestionSingleMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports